import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiBearerIam } from '~/services/api';
import { HttpData } from '~/utils/network/HttpData';
import { FileWithPath } from '@mantine/dropzone';

export type UserImportInspectRequest = {
  file: FileWithPath;
};

export type UserImportInspectResponse = {
  valid_emails: string[];
  duplicate_emails: string[];
  invalid_or_missing_emails: string[];
};

export const useUserImportInspect = (
  config?: UseMutationOptions<
    HttpData<UserImportInspectResponse>,
    Error,
    UserImportInspectRequest
  >
) => {
  return useMutation<
    HttpData<UserImportInspectResponse>,
    Error,
    UserImportInspectRequest
  >({
    mutationKey: ['user', 'import-inspect'],
    mutationFn: async (payload) => {
      const formData = new FormData();
      formData.append('file', payload.file);

      const response = await apiBearerIam({}).post<
        HttpData<UserImportInspectResponse>
      >('/iam/user/v1/import-inspect', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    },
    ...config,
  });
};
